import React from "react";
export interface IState {
	pickListTypes: PickListType[];
	pickListItems: PickListItemResponseDTO[];
	filterByPickListItem: (
		picklistType: string
	) => (filter: any, row: any) => boolean;
	setColumnValue: (pickListItemId: number) => string | undefined;
	getPickListItemDescription: (pickListItemId?: number) => string;
}
const initialState: IState = {
	pickListTypes: [] as PickListType[],
	pickListItems: [] as PickListItemResponseDTO[],
	filterByPickListItem: () => () => true,
	setColumnValue: () => "",
	getPickListItemDescription: () => "",
};

const PickListContext = React.createContext(initialState);

export type PicklistProviderState = IState;
export default PickListContext;
